import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-enterprise';

@Component({
    selector: 'app-category-structure-tooltip',
    templateUrl: './category-structure-tooltip.component.html',
    styleUrls: ['./category-structure-tooltip.component.scss'],
    standalone: false
})
export class CategoryStructureTooltipComponent<T>
  implements ITooltipAngularComp
{
  constructor() {}
  categories?: Category[];

  static columnPropsForComponent(callback: Callback<unknown>) {
    return {
      tooltipComponent: CLASS_NAME,
      tooltipComponentParams: {
        callback,
      },
      // tooltip must have a value for component to be made
      tooltipValueGetter: () => 'UNUSED VALUE',
    };
  }

  static frameworkComponentProp = () => ({
    [CLASS_NAME]: CategoryStructureTooltipComponent,
  });

  agInit(
    params: ITooltipParams & {
      callback: Callback<T>;
    },
  ): void {
    // this.files = params.value;
    this.categories = params.callback(params);
  }
}

interface Category {
  name: string;
}

type Callback<T> = (
  params: ITooltipParams & { data?: T },
) => Category[] | undefined;

const CLASS_NAME = CategoryStructureTooltipComponent.name;
